(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["read-more"] && !Shopify.designMode) return;
  try {
    (function () {
    var WORD_LIMIT = 55;

    function countWords(el) {
      return (el.textContent || '').replace(/\s+/g, ' ').trim().split(' ').filter(Boolean).length;
    }

    /**
     * Uses the Range API to cut everything after the WORD_LIMIT-th word.
     * Returns the parent element of the text node where the cut happened
     * (e.g. the last visible <p>), so the inline link can be appended inside it.
     */
    function truncateAtWordLimit(container) {
      if (!container.lastChild) return null;

      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
      var count = 0;
      var node;

      while ((node = walker.nextNode())) {
        var tokens = node.textContent.split(/(\s+)/);
        var localWords = 0;
        for (var k = 0; k < tokens.length; k++) {
          if (/\S/.test(tokens[k])) localWords++;
        }

        if (count + localWords >= WORD_LIMIT) {
          // Find the character offset right after the (WORD_LIMIT - count)th word.
          var remaining = WORD_LIMIT - count;
          var charIndex = 0;
          var wordsSeen = 0;

          for (var i = 0; i < tokens.length; i++) {
            if (/\S/.test(tokens[i])) {
              wordsSeen++;
              charIndex += tokens[i].length;
              if (wordsSeen === remaining) break;
            } else {
              charIndex += tokens[i].length;
            }
          }

          // Delete everything from this character position to the end of container.
          var range = document.createRange();
          range.setStart(node, charIndex);
          range.setEnd(container, container.childNodes.length);
          range.deleteContents();

          // Remove trailing whitespace left on the truncated text node.
          node.textContent = node.textContent.trimEnd();

          return node.parentElement || container;
        }

        count += localWords;
      }

      return null;
    }

    function lastDeepElement(el) {
      var child = el.lastElementChild;
      while (child && !child.textContent.trim()) {
        child = child.previousElementSibling;
      }
      if (!child) return el;
      return lastDeepElement(child);
    }

    function setup(container) {
      var fullHTML = container.innerHTML;
      var arrowIcon = (document.getElementById('read-more-arrow-icon') || {}).innerHTML || '';

      if (countWords(container) <= WORD_LIMIT) return;

      function showTruncated() {
        container.innerHTML = fullHTML;
        var targetEl = truncateAtWordLimit(container);
        if (targetEl) {
          targetEl.insertAdjacentHTML(
            'beforeend',
            '<a href="#" class="read-more-link-text" data-action="expand"><span class="text-read-more-label">Read More</span>' + arrowIcon + '</a>'
          );
        }
      }

      function showFull() {
        container.innerHTML = fullHTML;

        // Find the last meaningful element (like p, div, li, etc.)
        var elements = container.querySelectorAll('p, div, li, span, h1, h2, h3, h4, h5, h6');
        var target = elements[elements.length - 1] || container;

        target.insertAdjacentHTML(
          'beforeend',
          '<a href="#" class="read-more-link-text read-less" data-action="collapse"><span class="text-read-more-label">Read Less</span>' + arrowIcon + '</a>'
        );
      }

      container.addEventListener('click', function (e) {
        var trigger = e.target.closest('.read-more-link-text');
        if (!trigger) return;
        e.preventDefault();
        if (trigger.dataset.action === 'expand') {
          showFull();
        } else {
          showTruncated();
        }
      });

      showTruncated();
    }

    document.querySelectorAll('[data-read-more="true"]').forEach(setup);
  })();
  } catch(e) { console.error(e); }
})();

})();
